import PropTypes from 'prop-types';
import { TooltipService } from '../services/tooltip-service';

export const TooltipPosition = PropTypes.oneOf(TooltipService.getValidPositions());
